var React = require('react');

function PlusIconInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M5.5332 12.8711H19.5332","stroke":"black","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M12.5332 5.87109V19.8711","stroke":"black","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

PlusIconInline.defaultProps = {"width":"25","height":"25","viewBox":"0 0 25 25","fill":"none"};

module.exports = PlusIconInline;

PlusIconInline.default = PlusIconInline;
